import { CheckCircle2, Clock3, Eye, ShieldAlert } from 'lucide-react';

const iconByType = {
  detected: ShieldAlert,
  viewed: Eye,
  resolved: CheckCircle2,
  pending: Clock3,
};

const toneByType = {
  detected: 'text-red-500',
  viewed: 'text-[rgb(var(--brand))]',
  resolved: 'text-[rgb(var(--brand-700))]',
  pending: 'text-amber-500',
};

export default function ActivityTimeline({ items = [] }) {
  return (
    <div className="timeline-glow space-y-3">
      {items.map((item) => {
        const Icon = iconByType[item.kind] || Clock3;
        return (
          <article key={item.id} className="relative pl-8">
            <div className={`absolute left-0 top-1.5 flex h-6 w-6 items-center justify-center rounded-full bg-[rgba(var(--panel),0.96)] ${toneByType[item.kind] || toneByType.pending}`}>
              <Icon className="h-4 w-4" />
            </div>
            <div className="rounded-2xl border border-[rgba(var(--border),0.68)] bg-[rgba(var(--subpanel),0.94)] px-3 py-3">
              <div className="flex flex-wrap items-center justify-between gap-2">
                <p className="text-sm font-medium text-[rgb(var(--fg))]">{item.message}</p>
                <span className="text-[11px] font-semibold uppercase tracking-[0.14em] text-[rgba(var(--muted),0.9)]">{item.timestamp}</span>
              </div>
            </div>
          </article>
        );
      })}
    </div>
  );
}
